import {
  DOM_EVENT_NAME_CART_ADD,
  DOM_EVENT_NAME_CART_ADD_ONE,
  DOM_EVENT_NAME_CART_REFRESH,
  PUB_SUB_EVENTS,
  PUB_SUB_PAYLOADS,
  cartDebug,
  publish
} from "./chunk--chunk-CBS2FRJT.vbt.js";

// src/js/cart/cartActions.js
function cartAddItems(variantArray) {
  publish(
    PUB_SUB_EVENTS.cartAddRequest,
    PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartAddRequest]({
      variantArray
    })
  );
}
function cartAddOneLineItem(id, size, selling_plan = null) {
  const variantObj = {
    id,
    quantity: 1,
    properties: { Size: size },
    selling_plan
  };
  cartAddItems([variantObj]);
}
function cartUpdateQuantities(variantQuantityMap) {
  publish(
    PUB_SUB_EVENTS.cartUpdateRequest,
    PUB_SUB_PAYLOADS[PUB_SUB_EVENTS.cartUpdateRequest]({
      variantQuantityMap
    })
  );
}
function cartRefresh() {
  cartUpdateQuantities({});
}
function cartClear() {
  publish(PUB_SUB_EVENTS.cartClearRequest);
}
function cartAddFormLegacy(formData) {
  cartDebug("ProductForm ATC formData:");
  cartDebug(Object.fromEntries(formData));
  const jsonFormVals = {};
  for (let [key, val] of formData.entries()) {
    jsonFormVals[key] = val;
  }
  const { id, quantity, selling_plan } = jsonFormVals;
  cartDebug(jsonFormVals);
  const variantArray = [
    {
      id: parseInt(id),
      quantity: parseInt(quantity),
      selling_plan: parseInt(selling_plan) ?? null,
      properties: {
        Size: jsonFormVals["properties[Size]"] ?? ""
      }
    }
  ];
  cartAddItems(variantArray);
}
function addEventListenerCartRefreshLegacy() {
  document.addEventListener("ajaxcart refresh", (e) => {
    cartRefresh();
  });
}
function addEventListenerCartAdd() {
  document.addEventListener(DOM_EVENT_NAME_CART_ADD, (e) => {
    cartDebug("cartActions cartAddItems event listener");
    cartDebug(e.detail);
    const variantArray = e.detail?.variantArray;
    if (variantArray) {
      cartAddItems(variantArray);
    }
  });
}
function addEventListenerCartAddOne() {
  document.addEventListener(DOM_EVENT_NAME_CART_ADD_ONE, (e) => {
    cartDebug("cartActions cartAddOneLineItem event listener");
    cartDebug(e.detail);
    const id = e.detail?.id;
    const size = e.detail?.size;
    const selling_plan = e.detail?.selling_plan;
    if (id && size) {
      cartAddOneLineItem(id, size, selling_plan);
    }
  });
}
function addEventListenerCartRefresh() {
  document.addEventListener(DOM_EVENT_NAME_CART_REFRESH, (e) => {
    cartRefresh();
  });
}
var cartActions = {
  cartAddItems,
  cartAddOneLineItem,
  cartUpdateQuantities,
  cartRefresh,
  cartClear,
  cartAddFormLegacy
};
window.muradCartActions = cartActions;
function init() {
  addEventListenerCartAdd();
  addEventListenerCartAddOne();
  addEventListenerCartRefreshLegacy();
  addEventListenerCartRefresh();
}
init();

export {
  cartAddItems,
  cartRefresh,
  cartAddFormLegacy,
  cartActions
};
